<template>
	<div class="wrapper">
		<headerTag />
		<div class="orderDiv orderDiv1" style="margin-top: 4.8rem;">
			<img :src="picPath" alt="">
			<p>
				<span>{{name}}</span>
				<span>￥{{orderPrice}}</span>
			</p>
		</div>
		<div class="orderDiv orderDiv2">
			<p class="orderBorder">服务信息</p>
			<p>{{attrInfo}}</p>
		</div>
		<div class="orderDiv">
			<p class="orderBorder">订单编号：<span>{{orderNo}}</span></p>
			<p class="orderBorder">下单时间：<span>{{addDate}}</span></p>
			<p class="orderBorder" style="margin-bottom: 0;">
				订单状态：<span v-if="orderStatus == 1">待支付</span>
					   <span v-else-if="orderStatus == 2">已支付</span>
					   <span v-else-if="orderStatus == 3">已退款</span>
					   <span v-else-if="orderStatus == 4">已取消</span>
			</p>
		</div>
		<p class="orderBottom wrapper">
			<span>￥{{orderPrice}}</span>
			<a v-if="orderStatus == 1" @click="cancelOrder(orderNo)" :disabled="qxDisable">取消订单</a>
			<a v-if="orderStatus == 1" @click="gopay(orderNo)">去支付</a>
			<a v-else-if="orderStatus == 2" @click="runThis" style="width: 55%;">
				<img src="../../assets/images/detail/QQ.png" alt="" style="height: 1.4rem; vertical-align: -4px; margin-right: 4px;" />
				售后客服
			</a>
			<a v-else-if="orderStatus == 3" @click="runThis" style="width: 55%;">
				<img src="../../assets/images/detail/QQ.png" alt="" style="height: 1.4rem; vertical-align: -4px; margin-right: 4px;"" />
				售后客服
			</a>
			<a v-else-if="orderStatus == 4" @click="againDownOrder(productName,mealId)" class="again">重新下单</a>
		</p>
	</div>

</template>

<script>
   
    import "../../assets/css/order.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    import { Dialog } from 'vant'
    import {GetParamValue} from '../../assets/js/getParam.js' 
    import { openConsult } from '../../assets/js/common.js' 
	
	export default {
	    name: 'orderDetail',
		data(){
			  return {
			  	 qxDisable:false,
			 	 orderNo:'',
			 	 name:'',
			 	 picPath:'',
			 	 orderPrice:'',
			 	 addDate:'',
			 	 orderStatus:'',
			 	 attrInfo:'',
			 	 productName:'',
			 	 mealId:'',
			  }
		},
		methods: {
				loadOrderInfo(){
					this.axios({
					 	method: 'POST',
					 	url:'/order/findOrderInfo',
						params:{
							flag:1, //订单详情
							orderNo:this.orderNo
					 	},
					}).then((res)=>{
							if(res.data.code==1000){
								let _data=res.data.obj;
								this.orderPrice=_data.orderPrice;
								this.addDate=_data.addDate;
								this.name=_data.name;
								this.orderStatus=_data.orderStatus;
								this.productName=_data.productName;
								this.mealId=_data.mealId;
								this.picPath=GetParamValue.getProductPic(_data.productName);
								this.attrInfo=GetParamValue.getAreaName(_data.areaName)+""
								 	         +GetParamValue.getRegisterType(_data.registerType)+""
									 	     +GetParamValue.getQualificationType(_data.qualificationType)+""
								 	  	     +GetParamValue.getRegisterAreaType(_data.registerAreaType)+""
					 					     +GetParamValue.getBankType(_data.bankType)+""
					 					     +GetParamValue.getServerTerm(_data.serverTerm)+""
					 					     +GetParamValue.getChangeChoose(_data.changeChoose)+""
					 					     +GetParamValue.getIndustryType(_data.industryType)+""
					 					     +GetParamValue.getBusinessType(_data.businessType);
					 		}else if(res.data.code == 1110){
					  			//未登录
					  			let currPath=window.location.href;
					  			window.location.href='/login?targetUrl='+currPath;
			  				}else{
					 			Dialog.alert({
								   message: '网络异常，返回重试'
								 }).then(() => {
								  	this.$router.push({ name:'orderList' });
								 });
					 		}
					}).catch((err)=>{
						 Dialog.alert({
						   message: '网络异常，返回重试'
						 }).then(() => {
						  	this.$router.push({ name:'orderList' });
						 });
					})
				},
				runThis(){
					this.axios({
					    method: 'POST',
					    url:'/user/selectSaleQQ',
					}).then((res)=>{
						openConsult(res.data.obj);
					}).catch((err)=>{
						this.$message.error({message: '暂无客服人员'});
					}) 
				 },
				 //取消订单
				 cancelOrder(orderNo){
			 		//按钮不可点击
					this.qxDisable=true;
				 	Dialog.confirm({
					  title: '提示',
					  message: '确认要取消订单 '+orderNo+'？<br/>确认后将立即生效，无法撤回。'
					}).then(() => {
					  // 确认
					  this.axios({
					 	    method: 'POST',
					 	    url:'/order/cancel',
					 		params:{
					 			orderNo:orderNo
					 		},
					 	}).then((res)=>{
					 			//按钮可点击
								this.qxDisable=false;
					 			if (res.data.code == 1000) {
						            Dialog.alert({
									  message: '订单'+orderNo+'取消成功！'
									}).then(() => {
										// 返回订单列表
									  	window.location.href='/order/orderInfo';
									});
						        }else if(res.data.code == 1110){
						  			//未登录
						  			let currPath=window.location.href;
						  			window.location.href='/login?targetUrl='+currPath;
				  				}else if(res.data.code == 5103){
						        	this.$message.error({message: '该订单不属于待支付订单'});
						        }else{
						        	this.$message.error({message: '网络异常，请稍后重试'});
						        }
					 	}).catch((err)=>{
					 		 //按钮可点击
							 this.qxDisable=false;
					 		 this.$message.error({message: '网络异常，请稍后重试'});
					 	})
					}).catch(() => {
					  	// 取消
					  	//按钮可点击
						this.qxDisable=false;
					});
			 },
			 againDownOrder(productName,mealId){
			 	if(Number(productName)== 99){
					this.$router.push({ name:'productMeal', params: {id:mealId} });
				}else if(Number(productName)== 1){
					// 公司注册
					this.$router.push({ name:'againGszc', params: {pid:mealId} });
				}else if(Number(productName)== 2){
					// 代理记账
					this.$router.push({ name:'againDljz', params: {pid:mealId} });
				}else if(Number(productName)== 3){
					// 企业变更
					this.$router.push({ name:'againQybg', params: {pid:mealId} });
				}else if(Number(productName)== 4){
					// 地址异常处理
					this.$router.push({ name:'againDzyccl', params: {pid:mealId} });
				}else if(Number(productName)== 5){
					//开设基本户
					this.$router.push({ name:'againKsjbh', params: {pid:mealId} });
				}else if(Number(productName)== 6){
					//公司注销
					this.$router.push({ name:'againGszx', params: {pid:mealId} });
				}else if(Number(productName)== 7){
					//税务筹划
					this.$router.push({ name:'againSwch', params: {pid:mealId} });
				}else if(Number(productName)== 8){
					//发票申领
					this.$router.push({ name:'againFpsl', params: {pid:mealId} });
				}else if(Number(productName)== 9){
					//税务解非
					this.$router.push({ name:'againSwjf', params: {pid:mealId} });
				}else if(Number(productName)== 10){
					//年度汇算清缴
					this.$router.push({ name:'againNdhsqj', params: {pid:mealId} });
				}else if(Number(productName)== 11){
					//年度工商年报
					this.$router.push({ name:'againNdgsnb', params: {pid:mealId} });
				}else if(Number(productName)== 12){
					//食品经营许可证
					this.$router.push({ name:'againSpjyxkz', params: {pid:mealId} });
				}else if(Number(productName)== 13){
					//财税咨询
					this.$router.push({ name:'againCszx', params: {pid:mealId} });
				}else if(Number(productName)== 14){
					//香港公司注册
					this.$router.push({ name:'againXggszc', params: {pid:mealId} });
				}else if(Number(productName)== 15){
					//香港公司注销
					this.$router.push({ name:'againXggszx', params: {pid:mealId} });
				}else if(Number(productName)== 16){
					//开设一般户
					this.$router.push({ name:'againKsybh', params: {pid:mealId} });
				}else if(Number(productName)== 17){
					//刻章备案
					this.$router.push({ name:'againKzba', params: {pid:mealId} });
				}else if(Number(productName)== 18){
					//社保开户
					this.$router.push({ name:'againSbkh', params: {pid:mealId} });
				}else if(Number(productName)== 19){
					//开设公积金账户
					this.$router.push({ name:'againKsgjjzh', params: {pid:mealId} });
				}else if(Number(productName)== 20){
					//定制代记账方案
					this.$router.push({ name:'againDzdjzfa', params: {pid:mealId} });
				}else if(Number(productName)== 21){
					//旧账梳理
					this.$router.push({ name:'againJzsl', params: {pid:mealId} });
				}else if(Number(productName)== 22){
					//年报异常解非
					this.$router.push({ name:'againNbycjf', params: {pid:mealId} });
				}else if(Number(productName)== 23){
					//开票咨询
					this.$router.push({ name:'againKpzx', params: {pid:mealId} });
				}else if(Number(productName)== 24){
					//外勤上门服务
					this.$router.push({ name:'againWqsmfw', params: {pid:mealId} });
				}else if(Number(productName)== 25){
					//电商客服外包
					this.$router.push({ name:'againDskfwb', params: {pid:mealId} });
				}else if(Number(productName)== 26){
					//劳务派遣许可证
					this.$router.push({ name:'againLwpqxkz', params: {pid:mealId} });
				}else if(Number(productName)== 27){
					//道路运输许可证
					this.$router.push({ name:'againDlysxkz', params: {pid:mealId} });
				}else if(Number(productName)== 28){
					//游戏出版运营备案
					this.$router.push({ name:'againYxcbyyba', params: {pid:mealId} });
				}else if(Number(productName)== 29){
					//ODI境外投资
					this.$router.push({ name:'againJwtz', params: {pid:mealId} });
				}
			 },
			 // 去支付
			 gopay(orderNo){
				this.$router.push({ name:'paySure', params: {orderNo:orderNo} });
			 },
		},
	    components: {
			headerTag,
			Dialog,
			GetParamValue,
			openConsult
	    },
	    created(){
			this.orderNo = this.$route.params.orderNo;
			this.loadOrderInfo();
		},
	}
</script>


